import { Component } from '@angular/core';

// import { SettingsService } from './services/service.index';

@Component({
  selector: 'app-root',
  templateUrl: './app.main.component.html'
})
export class AppMainComponent {

  
  constructor( ) {}

}
